import Props from "./Props";

const ENV: Props = {
	API_URL: "https://service.ridevu.com",
	MASTER_API_KEY: "75-5-ab2ef",
	SENTRY_LOG_URL: "https://57b844f9bd4649acb4af143f8dd52e34@o4504099501178880.ingest.sentry.io/4504099504848897",
	UNLEASH_PROXY_URL: "https://unleash-proxy.privilegemovies.com/proxy",
	UNLEASH_AUTH_KEY: "JfRpqZdrPVvrkmMZdXeeAMVAUJyd3gvT",
	MAINTENANCE_CONFIG_URL: "https://cf.privilegemovies.com/remote-config/production.json",
	MOBILE_PAYMENT_URL: "https://payments.ridevu.com/purchase",
	PINPOINT_REGION: "us-east-2",
	PINPOINT_APP_ID: "ridevumbz-prod",
	PINPOINT_WEB_CLIENT_ID: "9b5c482612bb482ba38889773cca5f63",
	PINPOINT_USER_POOL_ID: "us-east-2_9b5c482612bb482ba38889773cca5f63",
	PINPOINT_IDENTITY_POOL_ID: "us-east-2:5b041fed-d1e2-46d5-90fe-8fcc724bb93d",
};

export default ENV;
